export default "__VITE_ASSET__CIhE9p71__"